import { AfterViewInit, Component, HostBinding, OnDestroy, ViewChild } from '@angular/core';
import { WizDateUtils } from '@wizeoo/akm-core-lib';
import {
  WizDateField,
  WizIcon,
  WizNumericInput,
  WizPopUp,
  WizRoot,
  WizTextInput,
  WizValidationContainerDirective,
  WizValidationError,
  WizEventManager,
  WizTranslationManager,
  WizTimefield
} from '@wizeoo/akm-component-lib';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE, WIDGET_GLOBAL_KIND } from '../../../../../model/enums';
import { FIELD_KIND, FeiKeyDef, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { IWidget } from '../../../../../manager/widgets/i-widget';
import { Baseline, Measure } from '@wizeoo/akm-message-lib';
import { CellPosition } from 'ag-grid-community';
import { FreedataArgsVO } from '../../../../../vo/core/freedataargs.vo';
import { FreedataValueVO } from '../../../../../vo/core/freedatavalue.vo';

@Component({
  selector: 'pivot-cell-editor',
  templateUrl: './pivot-cell.editor.html'
})
export class PivotCellEditor implements ICellEditorAngularComp, AfterViewInit, OnDestroy {

  @HostBinding('style.width') forcedW = '100%';
  @HostBinding('style.height') forcedH = '100%';
  @HostBinding('style.display') flex = 'flex';
  @HostBinding('style.align-items') ai = 'center';




  /**
   * constructeur
   */
  constructor() { }


  /** Zone de validation des champs de saisie */
  @ViewChild('mainGP', { read: WizValidationContainerDirective, static: false })
  private mainGP: WizValidationContainerDirective;

  @ViewChild('ti', { read: WizTextInput }) public ti: WizTextInput;
  @ViewChild('ni', { read: WizNumericInput }) public ni: WizNumericInput;
  @ViewChild('da', { read: WizDateField }) public da: WizDateField;
  @ViewChild('tf', { read: WizTimefield }) public tf: WizTimefield;


  private params: any; // la conf issue du grid
  
  private fkd: FeiKeyDef; // dans le cas d'une baseline
  private arg: FreedataArgsVO; // dans le cas d'un FDV
  private dataKind: string = FIELD_KIND.STRING; // le type de la donnée

  public widget: IWidget; // accesseur sur le pivot
  public mode: string; // FREEDATA ou BASELINE


  private currKey: string = null; // l'élément en saisie directe (valeur de clé)
  private doDelete: boolean = false; // on a appuyé sur suppr

  public isKey: boolean = false;
  public isNum: boolean = false;
  public isText: boolean = false;
  public isDate: boolean = false;
  public isTime: boolean = false;

  public textValue: string = null;
  public numValue: number = null;
  public dateValue: number = null;
  public timeValue: string = null;

  public forceCaps: string = ''; // forcer l'upperCase
  ngAfterViewInit() {
    // console.log('ngAfterViewInit', this.params);

    // Ecoute sur l'événement de rafraichissement de la grille pour récupération des données dans l'éditor
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.GRID_REFRESHED, this.refresh);

    // focus on the input
    setTimeout(() => this.feed(), 0);
  }

  ngOnDestroy() {
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.GRID_REFRESHED);
  }

  private feed(): void {
    // console.log('feed', this.params.charPress, this.params.keyPress);
    if (this.params.charPress) {
      // injection directe d'une nouvelle valeur
      this.currKey = this.params.charPress;
    }
    if(this.params.keyPress === 46) {
      this.doDelete = true;
    }

    let minValue: string = null;
    let maxValue: string = null;
    let nbDecimal: number = 0;
    let allowNegative: boolean = false;
    let upper: boolean = false;
    let editRegex: string = null;


    if(this.mode === WIDGET_GLOBAL_KIND.FREEDATA) { // mode freedata
      // console.log('feed', this.params.charPress, this.arg);
      if(!!this.arg) {
        minValue = this.arg.minValue?.toString() || null;
        maxValue = this.arg.maxValue?.toString() || null;
        nbDecimal = 2; //this.arg.nbDecimal || 0;
        allowNegative = true; // !!this.arg.allowNegative;
        upper = !!this.arg.upper;
        editRegex = this.arg.regex || null;
      }
    } else { // mode baseline
      const meas: Measure = this.fkd?.measure || this.params.colDef['measure'];
      if(!!meas) {
        minValue = meas.minValue || null;
        maxValue = meas.maxValue || null;
        nbDecimal = meas.nbDecimal || 0;
        allowNegative = !!meas.allowNegative;
        upper = !!meas.upper;
        editRegex = meas.editRegex || null;
      }
    }


    if (this.isText) {
      if(this.doDelete) { // suppr
        this.textValue = null;
      }
      this.ti.wizValue = this.textValue;
      this.ti.wizMaxChars = !!maxValue ? Number(maxValue) : 50;

      if(editRegex) {
        this.ti.wizRestrict = new RegExp('^'+editRegex+'$');
      }

      if(upper) {
        this.forceCaps = 'upper-case-input';
      }

      setTimeout(() => {
        this.ti.wizFocusInjector(this.currKey);
        // this.ti.wizFocus();
      }, 1);
    } else if (this.isNum) {  
      if(this.doDelete) { // suppr
        this.numValue = null;
      }
      this.ni.wizNumber = this.numValue;
      if(this.widget?.pivotMode && this.widget?.context?.mem === 3) { // mode saisie en masse avec ventilation, pas de contrôle de saisie min/max ici
        this.ni.wizMinNumber = null;
        this.ni.wizMaxNumber = null;
      } else {
        this.ni.wizMinNumber = !!minValue ? Number(minValue) : null;
        this.ni.wizMaxNumber = !!maxValue ? Number(maxValue) : null;
      }

      this.ni.nbDecimal = !!nbDecimal ? nbDecimal : 0;
      this.ni.allowNegative = !!allowNegative;
      setTimeout(() => {
        // this.ni.wizFocus();
        this.ni.wizFocusInjector(this.currKey);
      }, 1);
    } else if (this.isDate) {
      if(this.doDelete) { // suppr
        this.dateValue = null;
      }
      this.da.wizNumberValue = this.dateValue;
      this.da.wizMinDate = !!minValue ? WizDateUtils.stringToDate(minValue) : null;
      this.da.wizMaxDate = !!maxValue ? WizDateUtils.stringToDate(maxValue) : null;
      setTimeout(() => {
        this.da.wizFocusInjector(this.currKey);
      }, 1);
    } else if (this.isTime) {
      if(this.doDelete) { // suppr
        this.timeValue = null;
      }
      this.tf.wizHourValue = this.timeValue;
      setTimeout(() => {
        this.tf.wizFocusInjector(this.currKey);
      }, 1);
    }
  }

  agInit(params: any): void {
    this.params = params;
    this.widget = params.colDef.widget;
    let wl: WidgetLine = null;
    let fdv: FreedataValueVO = null;

    this.widget.activeFocus = true;

    if(this.widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA) { // édition de FDV
      // console.log('fdv', params);
      fdv = params.data;
      try {
        let field: string = params.colDef.fdvfield.split(WizConstants.FD_PARTS_SEPARATOR)[0]; 
        this.arg = this.widget.model.freedataEngine.getArgFromFD(fdv.freeDataCode, field);
        this.dataKind = this.arg.dataType || FIELD_KIND.STRING;
      } catch(e: any) {

      }

      this.mode = WIDGET_GLOBAL_KIND.FREEDATA;

    } else { // édition de baseline
      this.mode = WIDGET_GLOBAL_KIND.BASELINE;
      this.fkd = params.colDef.fkd; // en cas de baselines
      if (this.fkd?.isFilterKey) {
        this.isKey = true;
        this.dataKind = FIELD_KIND.STRING;
        // this.isText = true;
        // this.textValue = this.params.value;
      } else {
        let wl: WidgetLine = this.params?.data;
        const meas: Measure = this.fkd?.measure || params.colDef['measure'];
        this.dataKind = meas?.dataKind || FIELD_KIND.STRING;
        // this.widget.model.widgetEngine.lastFocusedCell.pce = this;        
        // mettre à jour this.widget.model.widgetEngine.lastFocusedCell

        // TODO TODO sur pivot, si pareil, pas écraser pce
        // console.log('feed focus pce', this.widget.model.widgetEngine.lastFocusedCell);
        // const meas: Measure = this.fkd?.measure || params.colDef['measure'];       
      }
    }
    
    switch (this.dataKind) {
      case FIELD_KIND.INT:
      case FIELD_KIND.NUMBER:
      // case FIELD_KIND.BOOLEAN:
        this.isNum = true;
        this.numValue = Number(this.params.value);
        break;
      case FIELD_KIND.DATE:
        this.isDate = true;
        this.dateValue = Number(this.params.value); // la saisie sera injectée sur afterInit pour la prise de focus
        break;
      case FIELD_KIND.TIME:
        this.isTime = true;
        this.timeValue =this.params.value;
        break;         
      case FIELD_KIND.STRING:
      case FIELD_KIND.COMMENT:
        this.isText = true;
        this.textValue = this.params.value;
        break;
      case FIELD_KIND.FILE:
        this.isText = true;
        this.textValue = this.params.value;
        this.imDead = true;
        break;
    }



    let focusedCell: CellPosition = {rowIndex: params?.rowIndex, column: params?.column, rowPinned: null};
    this.widget.model.widgetEngine.lastFocusedCell = {focusedCell, wl, fdv, pce: this, pivotUID: this.widget.uid};
    // mémorisation du focus
  }

  private imDead: boolean = false;

  /**
   * cellule modifiée par un retour de dataCommit, on ne génère pas de modif
   * @param bl 
   */
  yourDead(bl: Baseline | FreedataValueVO): void {
    // console.log('pce yourDead', bl);
    this.imDead = true;
    this.widget.activeFocus = false;
  }

  /* Component Editor Lifecycle methods */
  // the final value to send to the grid, on completion of editing
  getValue() {

    // console.log('editor getValue', this.params.value); 
    // TODO TODO sync dateField sur saisie + TAB
    let result: string = '';
    if(this.isDate) {
      this.da.prepareForCheck(); // on force le refresh de la date
    }
    if(this.isTime) {
      this.tf.prepareForCheck(); // on force le refresh de l'heure
    }
   
    const errors = this.mainGP.check(true, true);
    if (errors && errors.length > 0) {
      errors.forEach((wve: WizValidationError) => {
        let mess: string = WizTranslationManager.getInstance().translateKey(wve.wizError, wve.wizErrorParams);
        WizPopUp.toast(mess, WizIcon.TOAST_ERROR).show();
      });
      return this.params.value; // pas de changement
    }

    // console.log('err', errors);
    if (this.isText) {
      // une mesure de type texte
      result = this.ti.wizValue;
    } else if (this.isNum) {
      // une mesure numérique
      if (this.ni.wizValue !== null) {
        result = this.ni.wizNumber.toString();
      }
    } else if (this.isDate) {
      // une mesure de type date
      this.da.prepareForCheck(); // on force le refresh de la date
      // console.log('datecheck', this.da.wizDateValue);
      result = this.da.wizDateValue ? WizDateUtils.dateToString(this.da.wizDateValue) : null;
    } else if (this.isTime) {
      // une mesure de type heure
      this.tf.prepareForCheck(); // on force le refresh de la date
      // console.log('datecheck', this.da.wizDateValue);
      result = this.tf.wizHourValue ? this.tf.wizHourValue : null;
    }
    
    return result;
  }

  // Gets called once before editing starts, to give editor a chance to
  // cancel the editing before it even starts.
  isCancelBeforeStart() {
    // console.log('isCancelBeforeStart', this.params);

  if (this.params.colDef?.fkd?.datakind === FIELD_KIND.BOOLEAN || 
    this.params.colDef?.fkd?.datakind === FIELD_KIND.BINARY ||
    this.params.colDef?.fkd?.datakind === FIELD_KIND.FILTER ||
    this.params.colDef?.fkd?.datakind === FIELD_KIND.CROSS_FILTER ||
    this.params.colDef?.fkd?.datakind === FIELD_KIND.WORKFLOW ||
    this.params.colDef?.fkd?.datakind === FIELD_KIND.LIST ||
    this.params.colDef?.fkd?.datakind === FIELD_KIND.TRS_LABEL ||
    this.params.colDef?.fkd?.datakind === FIELD_KIND.THRESHOLD) { // pas de 2xclic sur le checkbox
    // console.log('no cbx on pivotcelleditor', this.params);
    this.widget.activeFocus = false;
    return true;
  }
  
  // édition des FDV
  // en cas de fdv, on doit tester le arg pour voir
  if(this.mode === WIDGET_GLOBAL_KIND.FREEDATA) {
    if (
      this.dataKind=== FIELD_KIND.OBJECT || 
      this.dataKind=== FIELD_KIND.BOOLEAN || 
      this.dataKind === FIELD_KIND.BINARY ||
      this.dataKind === FIELD_KIND.WORKFLOW ||
      this.dataKind === FIELD_KIND.LIST ||
      this.dataKind === FIELD_KIND.TRS_LABEL ||
      this.dataKind === FIELD_KIND.THRESHOLD) { // pas de 2xclic sur le checkbox
      // console.log('no cbx on pivotcelleditor', this.params);
      this.widget.activeFocus = false;
      return true;
    }
  }

   let result: boolean = this.params.colDef.widget.checkBeforeEdit(this.params);
   // console.log('isCancelBeforeStart result', result);
   this.widget.activeFocus = result;
   return !result;

    // return false;
  }

  // Gets called once when editing is finished (eg if Enter is pressed).
  // If you return true, then the result of the edit will be ignored.
  isCancelAfterEnd() {
    // our editor will reject any value greater than 1000
    // console.log('cancel sur modif datacommit', this.imDead);
    this.widget.activeFocus = false;
    return this.imDead; // this.value > 1000;
  }

  // rafraichissement de la donnée de l'éditor à partir du pivot
  public refresh(e:AlkEvent) {
    console.log('pce refresh', e);
    const value = this.widget.valueAccessor(this.params);
    // this.textValue = value;
    
    switch (this.dataKind) {
      case FIELD_KIND.TIME:
        this.textValue = value; 
        break;
      case FIELD_KIND.INT:
      case FIELD_KIND.NUMBER:
      case FIELD_KIND.BOOLEAN:
        this.numValue = Number(value);
        break;
      case FIELD_KIND.DATE:
        this.dateValue = Number(value); 
        break;
      case FIELD_KIND.TIME:
        this.timeValue = value; 
        break;
    }

    this.feed();  
  } 
}
